import { graphql } from 'gql'

export const GET_ASTERIO_BID_TOKEN = graphql(`
  query getAsterioBidToken {
    prebidManagerPublisherToken
  }
`)
